import { render, staticRenderFns } from "./InputRequired.vue?vue&type=template&id=c3021d00&scoped=true"
import script from "./InputRequired.vue?vue&type=script&lang=js"
export * from "./InputRequired.vue?vue&type=script&lang=js"
import style0 from "./InputRequired.vue?vue&type=style&index=0&id=c3021d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3021d00",
  null
  
)

export default component.exports